import { Grid, Tooltip, Typography } from '@alice-financial/pretext-ui'
import EditIcon from '@mui/icons-material/Edit'
import * as React from 'react'
import { HealthcheckAssignmentDialog } from '../components/HealthcheckAssignmentDialog'
import { HealthcheckRowData } from '../types'
import { isAssignableHealthcheck } from '../utils/onboardingWorkflowUtils'

interface HealthcheckAssigneeCellProps {
  row: HealthcheckRowData
}

export const HealthcheckAssigneeCell = ({
  row: { assignee, healthcheckType: healthcheckKey, healthcheckTitle },
}: HealthcheckAssigneeCellProps) => {
  const showAssignButton = isAssignableHealthcheck(healthcheckKey)
  const [isAssignDialogOpen, setIsAssignDialogOpen] = React.useState(false)
  const assigneeText = assignee?.name || (showAssignButton ? 'Unassigned' : '')

  const handleCellClick = () => {
    if (showAssignButton) {
      setIsAssignDialogOpen(true)
    }
  }

  return (
    <>
      <Grid
        container
        onClick={handleCellClick}
        alignItems="center"
        justifyContent="flex-end"
        spacing={1}
        height="100%"
        sx={
          showAssignButton
            ? {
                cursor: 'pointer',
              }
            : undefined
        }
      >
        <Typography variant="body2" noWrap>
          {assigneeText}
        </Typography>
        {showAssignButton && (
          <Tooltip title="Re-assign task">
            <EditIcon fontSize="small" color="primary" />
          </Tooltip>
        )}
      </Grid>

      {showAssignButton && (
        <HealthcheckAssignmentDialog
          open={isAssignDialogOpen}
          onClose={() => setIsAssignDialogOpen(false)}
          stepType={healthcheckKey}
          healthcheckTitle={healthcheckTitle}
          currentAssignee={assignee}
        />
      )}
    </>
  )
}
